import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Blockquote from '../../../components/Blockquote';
import Link from '../../../components/Link';
import { RadioGroup } from '../../../components/Radio';
import RadioWithImage from '../../../components/RadioWithImage';
import Support from '../../../components/Support/Support';
import SupportMobile from '../../../components/Support/SupportMobile';
import {
  addOrRemoveYearsToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';
import InvestMyself from './SavingEnrollmentStep3/InvestMyself';

export type StepProps = {
  data: any;
  collectStepData: (data: any) => void;
};

const radioCards = [
  {
    imageRef: 'quick-invest.png',
    cardTitle: 'Quick Invest',
    cardSubtitle: 'Select fund that is right for someone my age',
    id: 'quick-invest',
  },
  {
    imageRef: 'rollover-directly-to-me.png',
    cardTitle: 'Invest Myself',
    cardSubtitle: 'I want to select my own funds',
    id: 'invest-myself',
  },
];

const after1YearDate = new Date(
  new Date().setFullYear(new Date().getFullYear() + 1)
);

const after3YearDate = new Date(
  new Date().setFullYear(new Date().getFullYear() + 3)
);

const SavingsInvestment = ({ data, collectStepData }: StepProps) => {
  const handleInvestmentOptionChange = (event: any) => {
    collectStepData({
      ...data,
      investmentOption: event,
    });
  };

  return (
    <Container className="p-0 d-flex flex-row">
      <div className={'col-12 col-lg-8'}>
        <section className={'col-12'}>
          <div className="d-flex flex-row justify-content-between">
            <h5 className={'mt-12 mb-lg-9 text-sm-20-lg-24'}>
              How would you like invest?
            </h5>
            <div className={'mt-12 text-sm-20-lg-24 d-lg-none'}>
              <SupportMobile>
                <div className="p-0 mt-3">
                  <span className="fw-light text-sub1">
                    Here are a few things that will guide you to make the best
                    decision
                  </span>
                  <Link
                    rightIcon={light('chevron-right')}
                    onSelect={(selectedKey) =>
                      console.log(`selected ${selectedKey}`)
                    }
                    eventKey="test"
                    className="pt-3"
                    isAlignAtEnd
                    isBlue
                  >
                    <span className="text-caption lh-xs">Tax Breakdown</span>
                  </Link>
                  <Link
                    rightIcon={light('chevron-right')}
                    onSelect={(selectedKey) =>
                      console.log(`selected ${selectedKey}`)
                    }
                    eventKey="test"
                    className="pt-3"
                    isAlignAtEnd
                    isBlue
                  >
                    <span className="text-caption lh-xs">Min/Max Chart</span>
                  </Link>
                  <Link
                    rightIcon={light('chevron-right')}
                    onSelect={(selectedKey) =>
                      console.log(`selected ${selectedKey}`)
                    }
                    eventKey="test"
                    className="pt-3"
                    isAlignAtEnd
                    isBlue
                  >
                    <span className="text-caption lh-xs">
                      Contribution Calculator
                    </span>
                  </Link>
                </div>
              </SupportMobile>
            </div>
          </div>
          <div
            className={
              'mt-11 mt-lg-12 fw-light text-fs-6 lh-xs text-ligther-grey'
            }
          >
            <Blockquote>
              <div>
                <div className="m-0 text-sub1 fw-bolder text-ligther-grey">
                  <span>Did You Know?</span>
                </div>
                <div className="fw-light text-caption lh-xs pt-3 d-flex align-items-center">
                  <span>
                    Do you have the appropriate investment mix? If you aren't
                    working with an investment advisor you might want to think
                    about allocating your assets in an age-appropriate manner.
                  </span>
                </div>
              </div>
            </Blockquote>
          </div>
        </section>
        <section className="mt-13">
          <RadioGroup
            name={'no-labels'}
            value={data.investmentOption}
            onChange={handleInvestmentOptionChange}
          >
            <Row className="d-flex flex-column flex-lg-row m-0">
              {radioCards.map((radioCard, i) => {
                return (
                  <Col
                    className={`col-12 col-lg-4 mb-10 p-0 ${
                      i === 0 ? 'me-lg-10' : ''
                    }`}
                    key={i}
                  >
                    <RadioWithImage
                      cardData={radioCard}
                      selected={data.investmentOption !== radioCard.id}
                    />
                  </Col>
                );
              })}
            </Row>
          </RadioGroup>
        </section>
        {data.investmentOption === 'quick-invest' && (
          <section className="col-12 px-10 pt-11 pb-10 bg-white rounded-1">
            <Row className="m-0 pb-7 border-bottom">
              <Col className="p-0 col-5 col-lg-6">
                <h6 className="fw-normal m-0">Quick Investment</h6>
              </Col>
              <Col className="p-0 px-3">
                <div className="text-light-grey-normal fw-normal text-sub1 lh-xxs">
                  <span>1 Year Return</span>
                </div>
                <div className="text-light-grey-normal fw-light text-sub1 mt-1 lh-base">
                  <span>{`as of ${formatDate(
                    after1YearDate,
                    DateFormats.US
                  )}`}</span>
                </div>
              </Col>
              <Col className="p-0 ps-3">
                <div className="text-light-grey-normal fw-normal text-sub1 lh-xxs">
                  <span>3 Year Return</span>
                </div>
                <div className="text-light-grey-normal fw-light text-sub1 mt-1 lh-base">
                  <span>{`as of ${formatDate(
                    after3YearDate,
                    DateFormats.US
                  )}`}</span>
                </div>
              </Col>
            </Row>
            <Row className="m-0 mt-7 pb-7 border-bottom">
              <Col className="p-0 col-5 col-lg-6 pe-3">
                <h6 className="text-sub fw-normal m-0">
                  Vanguard Target Retire 2060 Tr I
                </h6>
                <Link
                  rightIcon={light('arrow-up-right-from-square')}
                  isBlue
                  isAlignAtEnd
                  style={{ maxWidth: 100 }}
                >
                  Fund Details
                </Link>
              </Col>
              <Col className="p-0 px-3">
                <div className="fw-light text-sub1 lh-xxs">
                  <span>28.58%</span>
                </div>
              </Col>
              <Col className="p-0 ps-3">
                <div className="fw-light text-sub1 lh-xxs">
                  <span>12.76%</span>
                </div>
              </Col>
            </Row>
            <Row className="m-0 mt-7">
              <Blockquote>
                <div className="fw-light text-sub1 text-light-grey lh-xs pt-3 d-flex align-items-center">
                  <span>
                    {`This is an age appropriate fund that adjusts risk over time
                    for someone your age (age 25) retiring in ${formatDate(
                      addOrRemoveYearsToGivenDate(new Date(), 40),
                      DateFormats.ONLY_YEAR
                    )} at age 65`}
                  </span>
                </div>
              </Blockquote>
            </Row>
          </section>
        )}
        {data.investmentOption === 'invest-myself' && (
          <InvestMyself data={data} collectData={collectStepData} />
        )}
      </div>
      <div className="d-none d-lg-block col-lg-4">
        <section className="mt-12">
          <Support>
            <div className="p-0">
              <span className="fw-light text-sub1">
                Here are a few things that will guide you to make the best
                decision
              </span>
              <Link
                rightIcon={light('chevron-right')}
                onSelect={(selectedKey) =>
                  console.log(`selected ${selectedKey}`)
                }
                eventKey="test"
                className="pt-3"
                isAlignAtEnd
                isBlue
              >
                <span className="text-caption lh-xs">Tax Breakdown</span>
              </Link>
              <Link
                rightIcon={light('chevron-right')}
                onSelect={(selectedKey) =>
                  console.log(`selected ${selectedKey}`)
                }
                eventKey="test"
                className="pt-3"
                isAlignAtEnd
                isBlue
              >
                <span className="text-caption lh-xs">Min/Max Chart</span>
              </Link>
              <Link
                rightIcon={light('chevron-right')}
                onSelect={(selectedKey) =>
                  console.log(`selected ${selectedKey}`)
                }
                eventKey="test"
                className="pt-3"
                isAlignAtEnd
                isBlue
              >
                <span className="text-caption lh-xs">
                  Contribution Calculator
                </span>
              </Link>
            </div>
          </Support>
        </section>
      </div>
    </Container>
  );
};

export default SavingsInvestment;
